import {PRICE_RANGE_FILTER_VALUE_DELIMITER} from '../../../modules/filter/filterConstants';
import {convertToInteger} from '../../../common/number/numberUtils';

function extractPriceValuesFromPriceFilterValue(priceFilterValue) {
  const [rawMinPrice, rawMaxPrice] = priceFilterValue?.split(PRICE_RANGE_FILTER_VALUE_DELIMITER);

  return {
    minPrice: (convertToInteger(rawMinPrice) || '').toString(),
    maxPrice: (convertToInteger(rawMaxPrice) || '').toString(),
  };
}

class FilterPriceRange {
  static fromFilter(priceFilter) {
    const {
      minPrice,
      maxPrice,
    } = extractPriceValuesFromPriceFilterValue(priceFilter.value);
    return new FilterPriceRange({
      minPrice,
      maxPrice,
    });
  }

  constructor({
    minPrice = '',
    maxPrice = '',
  } = {}) {
    this.minPrice = minPrice;
    this.maxPrice = maxPrice;
  }
}

export default FilterPriceRange;
